import type {CompRef} from '@wix/document-services-types'
import type {CreateExtArgs} from '@wix/document-manager-core'

import type {WidgetInfo} from './types'
import {COMP_TYPES} from '../../constants/constants'
import type {NicknamesExtensionAPI} from '../nicknames'
import type {NicknameContextExtensionAPI} from '../nicknameContext'

export function getSlotPlaceholdersData(
    createExtArgs: CreateExtArgs,
    widgetRootCompId: string
): NonNullable<WidgetInfo['slotPlaceholders']> {
    const slotPlaceholders = createExtArgs.pointers.structure.getComponentsByTypeForPage(
        COMP_TYPES.SLOT_PLACEHOLDER,
        widgetRootCompId
    )

    return slotPlaceholders.map(component => {
        const nicknameContext = (
            createExtArgs.extensionAPI as NicknameContextExtensionAPI
        ).nicknameContext.getNicknameContext(component as CompRef)

        if (typeof nicknameContext === 'undefined') {
            throw new Error(`Nickname context not found for component ${component.id}`)
        }

        const nicknameMap = (createExtArgs.extensionAPI as NicknamesExtensionAPI).nicknames.getComponentNickname(
            component as CompRef,
            nicknameContext
        )
        const nickname = nicknameMap[component.id]

        if (!nickname) {
            throw new Error(`Nickname not found for component ${component.id}`)
        }

        return {
            compRefId: component.id,
            slotKeyName: nickname
        }
    })
}
